export default __webpack_public_path__ + "static/media/tele-medicine.0c30532c.svg";